import React, { useReducer } from "react"
import { Action } from "../models/Action";
import PolicyManagementApi from "../api/policymanagement.api";
import { INSURANCE_CONTEXT_ACTIONS } from "./InsuracePurchaseContext";
import { HullApi } from "../api/hull.api";
import { EventEmitterService, EventKey } from "../services/EventEmitterService";
import { UserApi } from "../api/user.api";
import { removeDuplicateAdditionalInsured } from "../services/utils";
import policymanagementApi from "../api/policymanagement.api";
import { SessionService } from "../services/SessionService";
import StorageService from "../services/StorageService";
import { ActiveInsuranceModel } from "../models/insurance-models/ActiveInsuranceModel";
import { STATE_EXPIRY_TTL } from "../Constants";

export const ACTIONS = {
    LOAD_POLICIES: 'LOAD_POLICIES',
    LOADING_POLICIES: 'LOADING_POLICIES',
    SELECT_POLICY: 'SELECT_POLICY',
    SET_INCIDENT_INFO: 'SET_INCIDENT_INFO',
    SET_HULL_INFO: 'SET_HULL_INFO',
    SET_FILES_INFO: 'SET_FILES_INFO'
}

const CLAIM_CACHE_KEY = 'CLAIM_CACHE_KEY'

const defaultState = {
    dispatch: (action: Action) => {},
    getInsurance: (insuranceId) => {},
    setSelectedPolicy: (policy, dt) => {},
    clearStorage: () => {},
    date_happen: null,
    selected_policy: undefined,
    claim_incident_info: {},
    claim_files_info: {},
    claim_hull_info: { drones: [], equipment: []},
    all_policies: [],
    loading_policies: false
}

const calculateState = (state, action: Action) => {
    switch (action.type) {
        case ACTIONS.LOAD_POLICIES:
            return {...state,
                    all_policies: [...action.data.active_policies, ...action.data.scheduled_policies, ...action.data.previous_policies],
                    loading_policies: false}
        case ACTIONS.LOADING_POLICIES:
            return {...state, loading_policies: true }
        case ACTIONS.SET_INCIDENT_INFO: 
            return {...state, claim_incident_info: action.data}
        case ACTIONS.SELECT_POLICY: 
            return {...state,
                     selected_policy: action.data.policy,
                     date_happen: action.data.date,
                     claim_hull_info: { drones: [], equipment: []}, // Reset if changing policy
                    }
        case ACTIONS.SET_HULL_INFO:
            return {...state, claim_hull_info: action.data}
        case ACTIONS.SET_FILES_INFO:
            return {...state, claim_files_info: action.data}
      default: 
        return state
    }
};

const reducer = (state, action: Action) => {
    let newState = calculateState(state, action)
    stateToLocalStorage(newState)
    return newState
};

const stateToLocalStorage = (state) => {
    let savedStatte = Object.assign({}, state)
    delete savedStatte.all_policies
    delete savedStatte.loading_policies
    StorageService.setWithExpiry(CLAIM_CACHE_KEY, JSON.stringify(savedStatte), STATE_EXPIRY_TTL)
}

export const ClaimContextStore = React.createContext(defaultState)

const ClaimContext = (props) => {
    const [state, dispatch] = useReducer(reducer, defaultState, () => {
        let savedState = {}
        
        // Initialize from local storage
        if(StorageService.getWithExpiry(CLAIM_CACHE_KEY)) {
            savedState = JSON.parse(StorageService.getWithExpiry(CLAIM_CACHE_KEY))
            savedState.all_policies = []
            if(savedState.selected_policy) {
                savedState.selected_policy = Object.assign(new ActiveInsuranceModel(), savedState.selected_policy) 
            }
        }

        return Object.assign({}, defaultState, savedState)
    })

    const loadPolicies = async () => {
        dispatch(new Action(ACTIONS.LOADING_POLICIES))
        let res = await PolicyManagementApi.getAllInsurances()
        if(res.ok) {
            let dt = new Date()
            dispatch(new Action(ACTIONS.LOAD_POLICIES, {
                active_policies: res.parsedData.filter((item) => item.insuranceStart < dt && dt < item.insuranceEnd),
                scheduled_policies: res.parsedData.filter((item) => item.insuranceStart > dt),
                previous_policies: res.parsedData.filter((item) => item.insuranceEnd < dt)
            }))
        }
    }

    const getInsurance = (insuranceId) => {
        return state.all_policies.find(insurance => insurance.insuranceId == insuranceId)
    }

    const setSelectedPolicy = (policy, dt) => {
        dispatch(new Action(ACTIONS.SELECT_POLICY, {policy: policy, date: dt}))
    }

    const clearStorage = () => StorageService.removeItem(CLAIM_CACHE_KEY)

    React.useEffect(() => {
        loadPolicies()

        return function cleanup() {
            
        }
    }, [])

    

    return (<ClaimContextStore.Provider value={{ ...state, dispatch, getInsurance, setSelectedPolicy, clearStorage }}>
            {props.children}
        </ClaimContextStore.Provider>)   
}

export default ClaimContext



